import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-8 w-8", dark = false }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="16" fill={dark ? "#FBF9F5" : "#0F172A"} />
    <path d="M44 20.5A16 16 0 1 0 44 43.5" fill="none" stroke={dark ? "#0F172A" : "#FBF9F5"} strokeWidth="7" strokeLinecap="round" />
    <circle cx="46" cy="32" r="5" fill="#FF4D4D" />
  </svg>
);

export const Logo = ({ dark = false, testId }) => (
  <Link to="/#top" data-testid={testId} className="group flex items-center gap-2.5">
    <span className="transition-transform duration-500 group-hover:rotate-[-12deg]">
      <LogoMark dark={dark} />
    </span>
    <span className={`font-display text-2xl leading-none ${dark ? "text-[#FBF9F5]" : "text-ink"}`}>
      Clevanta<span className="text-coral">.</span>
    </span>
  </Link>
);
